/**
 * defa.views.NotificationsDeleteForm
 * A card for deleting all Notifications
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'scripts/defa/notifications/template-notifications-delete-form.jst.html';

const selectors = {
	cancel             : '[data-click=notifications-delete-cancel]',
	errorText    : '[data-text=delete-all-notifications-error]'
};

const NotificationsDeleteForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	
	template: template,
	ui: {
		cancel : selectors.cancel,
		error: selectors.errorText
	},

	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attempts to save the information to the Model.
	 * @void
	 */
	submit: function () {
		let self = this
		this.model.deleteAllNotifications({
			success: function (response) {
				self.idle()
				console.log('Notifications deleted')
				self.trigger('nav', 'all', [self.model.get('id') ]);
			},
			error: function (error) {
				self.idle()
				console.error(error)
				self.ui.error.append(error)
			}
		});
	},
	
} );


export default NotificationsDeleteForm;
